import { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { connectSlackCallback } from "../lib/api";
import { Alert, Icon } from "../design/ui";

export function SlackCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"connecting" | "success" | "error">("connecting");
  const [teamName, setTeamName] = useState("");
  const [dmSent, setDmSent] = useState(false);
  const [error, setError] = useState("");
  const didRun = useRef(false);

  useEffect(() => {
    if (didRun.current) return;
    didRun.current = true;

    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const errorParam = searchParams.get("error");

    if (errorParam) {
      setError(`Slack denied the connection: ${errorParam}`);
      setStatus("error");
      return;
    }

    if (!code || !state) {
      setError("Invalid callback URL. Did you arrive here from Slack?");
      setStatus("error");
      return;
    }

    connectSlackCallback(code, state)
      .then((result) => {
        setTeamName(result.teamName);
        setDmSent(result.dmSent);
        setStatus("success");
        setTimeout(() => navigate("/settings"), 2000);
      })
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : "Connection failed");
        setStatus("error");
      });
  }, [searchParams, navigate]);

  if (status === "connecting") {
    return (
      <div className="kt-center">
        <span className="kt-spinner" />
        <span>Connecting your Slack workspace…</span>
      </div>
    );
  }

  if (status === "success") {
    return (
      <div className="kt-center">
        <Icon name="circle-check" size={40} color="var(--kt-teal)" />
        <h2 className="ab-h2" style={{ color: "var(--kt-ink)" }}>Connected!</h2>
        <p style={{ color: "var(--kt-text-secondary)", textAlign: "center" }}>
          <span style={{ color: "var(--kt-ink)", fontWeight: 500 }}>{teamName}</span> is now linked to your brain.
          {dmSent && " Check your Slack DMs for a confirmation message."}
        </p>
        <p style={{ color: "var(--kt-text-muted)", fontSize: 13 }}>Redirecting to settings…</p>
      </div>
    );
  }

  return (
    <div className="kt-center">
      <Alert tone="danger">{error}</Alert>
      <Link to="/settings" style={{ color: "var(--kt-teal-ink)", fontSize: 13 }}>
        Back to settings
      </Link>
    </div>
  );
}
